module.exports = __webpack_public_path__ + "8a22e3532640b147dadbae645258a1ca.svg";